import { ABILITIES } from "@marshmallow-duel/simulation";

import { abilityName } from "../ability-names";
import { OriginalDialog } from "./OriginalDialog";

import type { Language, MatchRules } from "@marshmallow-duel/simulation";
import type { TranslationKey } from "../i18n";

interface AbilitiesDialogProps {
  readonly language: Language;
  readonly rules: MatchRules;
  readonly t: (key: TranslationKey) => string;
  readonly onChange: (rules: MatchRules) => void;
  readonly onClose: () => void;
}

export const AbilitiesDialog = ({ language, rules, t, onChange, onClose }: AbilitiesDialogProps) => {
  const selected = new Set(rules.abilityIds);
  const toggle = (id: number) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    onChange({ ...rules, abilityIds: [...next].sort((left, right) => left - right) });
  };
  return (
    <OriginalDialog title={t("abilities.title")} onClose={onClose} wide>
      <button type="button" className="small-original-button ability-toggle" onClick={() => onChange({ ...rules, abilityIds: selected.size === ABILITIES.length ? [] : ABILITIES.map(({ id }) => id) })}>{t("abilities.toggleAll")}</button>
      <div className="ability-grid">
        {ABILITIES.map((ability) => (
          <label key={ability.id} className="ability-line">
            <input type="checkbox" checked={selected.has(ability.id)} onChange={() => toggle(ability.id)} />
            <img src={`/assets/original/sprites/${ability.icon}/0.png`} alt="" />
            <span>{abilityName(language, ability.id)}</span>
          </label>
        ))}
      </div>
    </OriginalDialog>
  );
};
